import { tt } from '@agos/shared'

/**
 * The rights a recipe's writes ask - `FRONTEND.md` §9.758, `BACKEND.md` §10A.413 (owner, folded into O119).
 *
 * <p>`POST /recipes`, `PUT /recipes/{id}` and `DELETE /recipes/{id}` were `@RequireAuth("main_admin")`, and **no
 * screen asked anything**: *Recepty*, the recipe dialog and the product dialog's recipe block offered every visitor a
 * write the server refused. §10A.413 opens them to two new keys, each the write key alone - `recipes`, the screen's own
 * key, is held by Nesvady's *Čašník*, and a recipe decides what a product costs and what it earns.
 *
 * <p>Asked through `hasPermission`, which is true for the main administrator and otherwise reads the person's rights.
 */
export const RECIPES_EDIT = 'recipes_edit'
export const RECIPES_DELETE = 'recipes_delete'

/** Which recipe writes this person is offered. */
export interface RecipeRights {
  /** Create and edit - *Pridať recept*, *Upraviť*, the dialog's save, the product dialog's recipe block. */
  edit: boolean
  /** *Zmazať* on a recipe. */
  delete: boolean
}

export function recipeRightsFor(hasPermission: (permission: string) => boolean): RecipeRights {
  return { edit: hasPermission(RECIPES_EDIT), delete: hasPermission(RECIPES_DELETE) }
}

/**
 * Whether the product dialog's save writes the recipe too - §9.221's rule and §9.758's.
 *
 * **An untouched recipe is not written** (§9.221), and **a product saved by somebody without `recipes_edit` does not
 * write the recipe** however it got touched: the product is that person's to save, the recipe is not, and a refused
 * recipe write after a stored product reads *Produkt sa uložil, recept nie* - a save that half worked.
 */
export function writesRecipe(touched: boolean, mayEditRecipe: boolean): boolean {
  return touched && mayEditRecipe
}

/** Said where a recipe is shown and cannot be changed - the right, under the roles screen's own label. */
export function recipeRefusal(): string {
  return `${tt('Recept upravuje len ten, kto má právo')} „${tt('Recepty - Upraviť')}“.`
}

/**
 * Said on *Recepty* when it offers nothing at all - one sentence for a screen that became read-only, null otherwise.
 * A person who may delete and not edit still has a control on every row, so the page is not read-only for them.
 */
export function recipesReadOnlyNote(rights: RecipeRights): string | null {
  if (rights.edit || rights.delete) return null
  return `${tt('Recepty tu len vidíte - pridať, upraviť a zmazať ich môže ten, kto má práva')} „${tt('Recepty - Upraviť')}“ ${tt('a')} „${tt('Recepty - Zmazať')}“.`
}
